import { render } from "./DnePay.vue?vue&type=template&id=2fdc6cf4&scoped=true"
import script from "./DnePay.vue?vue&type=script&lang=js"
export * from "./DnePay.vue?vue&type=script&lang=js"

import "@/assets/scss/_entitiesPage.scss?vue&type=style&index=0&id=2fdc6cf4&lang=scss&scoped=true"
import "./custom-pay.scss?vue&type=style&index=1&id=2fdc6cf4&lang=scss&scoped=true"
import "./DnePay.vue?vue&type=style&index=2&id=2fdc6cf4&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdc6cf4"]])

export default __exports__